import React, { Fragment, useCallback, useState } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  FormGroup,
  Label,
  CardTitle,
  Input,
  Form,
  Table
} from "reactstrap";
import Select from "react-select";
import CustomSelect from "Components/CustomSelect";
import moment from "moment";
import Switch from "rc-switch";
import ReactAutosuggest from "Components/ReactAutosuggest";
import Rating from "Components/Rating";
import { SliderTooltip, RangeTooltip } from "Components/SliderTooltip";
import FineUploaderTraditional from "fine-uploader-wrappers";
import Gallery from "react-fine-uploader";

import "rc-switch/assets/index.css";
import "rc-slider/assets/index.css";
import "react-rater/lib/react-rater.css";
import "react-fine-uploader/gallery/gallery.css";

const uploader = new FineUploaderTraditional({
  options: {
    chunking: {
      enabled: false
    },
    deleteFile: {
      enabled: true,
      endpoint: "/uploads"
    },
    request: {
      endpoint: "/uploads"
    }
  }
});

const countries = [
  {
    name: "Afghanistan"
  },
  {
    name: "Albania"
  },
  {
    name: "Algeria"
  },
  {
    name: "Andorra"
  },
  {
    name: "Angola"
  },
  {
    name: "Argentina"
  },
  {
    name: "Armenia"
  },
  {
    name: "Aruba"
  },
  {
    name: "Australia"
  },
  {
    name: "Austria"
  },
  {
    name: "Azerbaijan"
  },
  {
    name: "Bahamas, The"
  },
  {
    name: "Bahrain"
  },
  {
    name: "Bangladesh"
  },
  {
    name: "Barbados"
  },
  {
    name: "Belarus"
  },
  {
    name: "Belgium"
  },
  {
    name: "Belize"
  },
  {
    name: "Benin"
  },
  {
    name: "Bhutan"
  },
  {
    name: "Bolivia"
  },
  {
    name: "Bosnia and Herzegovina"
  },
  {
    name: "Botswana"
  },
  {
    name: "Brazil"
  },
  {
    name: "Brunei"
  },
  {
    name: "Bulgaria"
  },
  {
    name: "Burkina Faso"
  },
  {
    name: "Burma"
  },
  {
    name: "Burundi"
  },
  {
    name: "Cambodia"
  },
  {
    name: "Cameroon"
  },
  {
    name: "Canada"
  },
  {
    name: "Central African Republic"
  },
  {
    name: "Chad"
  },
  {
    name: "Chile"
  },
  {
    name: "China"
  },
  {
    name: "Colombia"
  },
  {
    name: "Comoros"
  },
  {
    name: "Congo, Democratic Republic of the"
  },
  {
    name: "Congo, Republic of the"
  },
  {
    name: "Costa Rica"
  },
  {
    name: "Cote d'Ivoire"
  },
  {
    name: "Croatia"
  },
  {
    name: "Cuba"
  },
  {
    name: "Curacao"
  },
  {
    name: "Cyprus"
  },
  {
    name: "Czechia"
  },
  {
    name: "Denmark"
  },
  {
    name: "Djibouti"
  },
  {
    name: "Dominica"
  },
  {
    name: "Dominican Republic"
  },
  {
    name: "Ecuador"
  },
  {
    name: "Egypt"
  },
  {
    name: "El Salvador"
  },
  {
    name: "Equatorial Guinea"
  },
  {
    name: "Eritrea"
  },
  {
    name: "Estonia"
  },
  {
    name: "Eswatini"
  },
  {
    name: "Ethiopia"
  },
  {
    name: "Fiji"
  },
  {
    name: "Finland"
  },
  {
    name: "France"
  },
  {
    name: "Gabon"
  },
  {
    name: "Gambia, The"
  },
  {
    name: "Georgia"
  },
  {
    name: "Germany"
  },
  {
    name: "Ghana"
  },
  {
    name: "Greece"
  },
  {
    name: "Grenada"
  },
  {
    name: "Guatemala"
  },
  {
    name: "Guinea"
  },
  {
    name: "Guinea-Bissau"
  },
  {
    name: "Guyana"
  },
  {
    name: "Haiti"
  },
  {
    name: "Holy See"
  },
  {
    name: "Honduras"
  },
  {
    name: "Hong Kong"
  },
  {
    name: "Hungary"
  },
  {
    name: "Iceland"
  },
  {
    name: "India"
  },
  {
    name: "Indonesia"
  },
  {
    name: "Iran"
  },
  {
    name: "Iraq"
  },
  {
    name: "Ireland"
  },
  {
    name: "Israel"
  },
  {
    name: "Italy"
  },
  {
    name: "Jamaica"
  },
  {
    name: "Japan"
  },
  {
    name: "Jordan"
  },
  {
    name: "Kazakhstan"
  },
  {
    name: "Kenya"
  },
  {
    name: "Kiribati"
  },
  {
    name: "Korea, North"
  },
  {
    name: "Korea, South"
  },
  {
    name: "Kosovo"
  },
  {
    name: "Kuwait"
  },
  {
    name: "Kyrgyzstan"
  },
  {
    name: "Laos"
  },
  {
    name: "Latvia"
  },
  {
    name: "Lebanon"
  },
  {
    name: "Lesotho"
  },
  {
    name: "Liberia"
  },
  {
    name: "Libya"
  },
  {
    name: "Liechtenstein"
  },
  {
    name: "Lithuania"
  },
  {
    name: "Luxembourg"
  },
  {
    name: "Madagascar"
  },
  {
    name: "Malawi"
  },
  {
    name: "Malaysia"
  },
  {
    name: "Maldives"
  },
  {
    name: "Mali"
  },
  {
    name: "Malta"
  },
  {
    name: "Marshall Islands"
  },
  {
    name: "Mauritania"
  },
  {
    name: "Mauritius"
  },
  {
    name: "Mexico"
  },
  {
    name: "Micronesia"
  },
  {
    name: "Moldova"
  },
  {
    name: "Monaco"
  },
  {
    name: "Mongolia"
  },
  {
    name: "Montenegro"
  },
  {
    name: "Morocco"
  },
  {
    name: "Mozambique"
  },
  {
    name: "Namibia"
  },
  {
    name: "Nauru"
  },
  {
    name: "Nepal"
  },
  {
    name: "Netherlands"
  },
  {
    name: "New Zealand"
  },
  {
    name: "Nicaragua"
  },
  {
    name: "Niger"
  },
  {
    name: "Nigeria"
  },
  {
    name: "North Korea"
  },
  {
    name: "North Macedonia"
  },
  {
    name: "Norway"
  },
  {
    name: "Oman"
  },
  {
    name: "Pakistan"
  },
  {
    name: "Palau"
  },
  {
    name: "Palestinian Territories"
  },
  {
    name: "Panama"
  },
  {
    name: "Papua New Guinea"
  },
  {
    name: "Paraguay"
  },
  {
    name: "Philippines"
  },
  {
    name: "Poland"
  },
  {
    name: "Portugal"
  },
  {
    name: "Qatar"
  },
  {
    name: "Romania"
  },
  {
    name: "Russia"
  },
  {
    name: "Rwanda"
  },
  {
    name: "Saint Kitts and Nevis"
  },
  {
    name: "Saint Lucia"
  },
  {
    name: "Saint Vincent and the Grenadines"
  },
  {
    name: "Samoa"
  },
  {
    name: "San Marino"
  },
  {
    name: "Sao Tome and Principe"
  },
  {
    name: "Saudi Arabia"
  },
  {
    name: "Senegal"
  },
  {
    name: "Serbia"
  },
  {
    name: "Seychelles"
  },
  {
    name: "Sierra Leone"
  },
  {
    name: "Singapore"
  },
  {
    name: "Sint Maarten"
  },
  {
    name: "Slovakia"
  },
  {
    name: "Solomon Islands"
  },
  {
    name: "Somalia"
  },
  {
    name: "South Africa"
  },
  {
    name: "South Korea"
  },
  {
    name: "South Sudan"
  },
  {
    name: "Spain"
  },
  {
    name: "Sri Lanka"
  },
  {
    name: "Sudan"
  },
  {
    name: "Suriname"
  },
  {
    name: "Swaziland"
  },
  {
    name: "Sweden"
  },
  {
    name: "Switzerland"
  },
  {
    name: "Syria"
  },
  {
    name: "Taiwan"
  },
  {
    name: "Tajikistan"
  },
  {
    name: "Tanzania"
  },
  {
    name: "Thailand"
  },
  {
    name: "Timor-Leste"
  },
  {
    name: "Togo"
  },
  {
    name: "Tonga"
  },
  {
    name: "Trinidad and Tobago"
  },
  {
    name: "Turkey"
  },
  {
    name: "Turkmenistan"
  },
  {
    name: "Tuvalu"
  },
  {
    name: "Uganda"
  },
  {
    name: "Ukraine"
  },
  {
    name: "United Arab Emirates"
  },
  {
    name: "United Kingdom"
  },
  {
    name: "Uruguay"
  },
  {
    name: "Uzbekistan"
  },
  {
    name: "Vanuatu"
  },
  {
    name: "Venezuela"
  },
  {
    name: "Vietnam"
  },
  {
    name: "Yemen"
  },
  {
    name: "Zambia"
  },
  {
    name: "Zimbabwe"
  }
];

const Gender = [
  { label: "Male", value: "male", key: 0 },
  { label: "Female", value: "female", key: 1 }
];
const Hobbies = [
  { label: "Playing Football", value: "football", key: 0 },
  { label: "Playing Cricket", value: "cricket", key: 1 },
  { label: "Collecting Coins", value: "coins", key: 0 },
  { label: "Traveling", value: "traveling", key: 1 },
  { label: "Cooking", value: "cooking", key: 1 }
];

function Tables() {
  const [selectedOptions, setSelectedOptions] = useState<unknown[]>([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [switchCheckedBox, setSwitchCheckedBox] = useState(false);
  const [switchCheckedBoxInverse, setSwitchCheckedBoxInverse] = useState(true);
  const [switchCheckedBoxS, setSwitchCheckedBoxS] = useState(true);
  const [switchCheckedBoxSInverse, setSwitchCheckedBoxSInverse] = useState(
    false
  );
  const [suggestionValue, setSuggestionValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [tags, setTags] = useState<unknown>(undefined);

  const onSuggestionChange = useCallback(
    (_event: unknown, { newValue }: { newValue: string }) => {
      setSuggestionValue(newValue);
    },
    []
  );

  const handleTagChange = useCallback((nextTags: unknown) => {
    setTags(nextTags);
  }, []);

  const handleChangeMulti = useCallback((next: unknown) => {
    setSelectedOptions(Array.isArray(next) ? next : []);
  }, []);

  const handleChange = useCallback((next: unknown) => {
    if (next && typeof next === "object" && "value" in next) {
      setSelectedOption(String((next as { value: unknown }).value));
    } else if (typeof next === "string") {
      setSelectedOption(next);
    } else {
      setSelectedOption("");
    }
  }, []);

  return (
    <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.forms-input" />}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <CardTitle> Basic Table</CardTitle>
                <Row>
                  <Colxx lg="12">
                    <Table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Username</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>Mark</td>
                          <td>Otto</td>
                          <td>@mdo</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>Jacob</td>
                          <td>Thornton</td>
                          <td>@fat</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>Larry</td>
                          <td>the Bird</td>
                          <td>@twitter</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <CardTitle>Basic Dark Table</CardTitle>
                <Row>
                  <Colxx xxs="12">
                    <Table dark>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Username</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>Mark</td>
                          <td>Otto</td>
                          <td>@mdo</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>Jacob</td>
                          <td>Thornton</td>
                          <td>@fat</td>
                        </tr>
                        <tr>
                          <th scope="row">3</th>
                          <td>Larry</td>
                          <td>the Bird</td>
                          <td>@twitter</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx lg="12">
            <Card>
              <CardBody>
                <CardTitle>Stripped Table</CardTitle>
                <Table striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Username</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Mark</td>
                      <td>Otto</td>
                      <td>@mdo</td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Jacob</td>
                      <td>Thornton</td>
                      <td>@fat</td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Larry</td>
                      <td>the Bird</td>
                      <td>@twitter</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <CardTitle>Bordered Table</CardTitle>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Username</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Mark</td>
                      <td>Otto</td>
                      <td>@mdo</td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Jacob</td>
                      <td>Thornton</td>
                      <td>@fat</td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Larry</td>
                      <td>the Bird</td>
                      <td>@twitter</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
        <Row className="mb-4">
          <Colxx lg="12">
            <Card>
              <CardBody>
                <CardTitle>Borderless Table</CardTitle>
                <Table borderless>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Username</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Mark</td>
                      <td>Otto</td>
                      <td>@mdo</td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Jacob</td>
                      <td>Thornton</td>
                      <td>@fat</td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Larry</td>
                      <td>the Bird</td>
                      <td>@twitter</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
        <Row className="mb-4">
          <Colxx lg="12">
            <Card>
              <CardTitle>Hoverable Table</CardTitle>
              <CardBody>
                <Table hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Username</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Mark</td>
                      <td>Otto</td>
                      <td>@mdo</td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Jacob</td>
                      <td>Thornton</td>
                      <td>@fat</td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Larry</td>
                      <td>the Bird</td>
                      <td>@twitter</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
        <Row>
          <Colxx lg="12">
            <Card>
              <CardBody>
                <CardTitle>Responsive Table</CardTitle>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Table heading</th>
                      <th>Table heading</th>
                      <th>Table heading</th>
                      <th>Table heading</th>
                      <th>Table heading</th>
                      <th>Table heading</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                      <td>Table cell</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
    </Fragment>
  );
}

export default Tables;
